import { render, staticRenderFns } from "./RedirectDeposit.vue?vue&type=template&id=dfb3f5dc&scoped=true"
import script from "./RedirectDeposit.vue?vue&type=script&lang=js"
export * from "./RedirectDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb3f5dc",
  null
  
)

export default component.exports